import React from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Registers the self-destroying SW from vite-plugin-pwa so old Workbox
// clients uninstall themselves. Also wipe any leftover Cache Storage.
registerSW({ immediate: true });
if (typeof caches !== 'undefined') {
    void caches.keys().then(keys =>
        Promise.all(keys.map(key => caches.delete(key)))
    );
}

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
